<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <sb-button (click)="requestDebounced()" [disabled]="loading" [loading]="loading"
             classes="btn-default actionButtonMinWidth" container="body" ngbTooltip="{{ 'lang.globals.refresh' | translate }}"
             placement="top">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
  <a *ngPermissions="permissionService.Permission.playback_schedule_create" [queryParams]="{returnTo: util.getPageLink()}"
     [sbRouterLink]="util.RoutingID.scheduleCreate">
    <button class="btn btn-success">
      <sb-icon class="mr-1" icon="plus"></sb-icon>
      {{ 'lang.schedules.newSchedule' | translate }}
    </button>
  </a>
</ng-container>

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper (filterChange)="requestDebounced()" (optionsChange)="requestDebounced($event)"
                  [headerClasses]="['stickyHeader']" [itemName]="'schedules'" [itemsData]="schedules" [iterateTableRows]="showList"
                  [loading]="loading" [options]="options" [showExactMatch]="true" headline="{{'lang.schedules.schedules' | translate}}">

  <!------------------------------

       Header More

  ------------------------------->

  <div header-more>
    <div class="form-check form-switch">
      <input [ngModel]="showList" (ngModelChange)="toggleListView()" type="checkbox" role="switch" class="form-check-input"
             id="ListView">
      <label class="form-check-label"
             for="ListView">{{ 'lang.globals.showInList' | translate }}</label>
    </div>
  </div>

  <!------------------------------

      Table Header

------------------------------->

  <ng-template #thead>
    <tr>
      <th *ngIf="(discussionService?.showRibbon || discussionService?.showDiscussionSideBar) && showList"
          class="sticky-col first-col tableBg"></th>
      <th>{{ 'lang.globals.id' | translate }}</th>
      <th>{{ 'lang.globals.level' | translate }}</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.filters' | translate }}</th>
      <th>{{ 'lang.globals.slots' | translate }}</th>
      <th>{{ 'lang.globals.modifiedAt' | translate }}</th>
      <th class="text-end"></th>
    </tr>
  </ng-template>
  <!------------------------------


    Table Body

------------------------------->
  <ng-template #tbody let-schedule>
    <ng-container *ngIf="!showList">
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: schedules, level: 0 }"></ng-container>
    </ng-container>
    <ng-container *ngIf="showList">
      <tr>
        <ng-container *ngTemplateOutlet="tds; context:{ schedule: schedule, level: 0 }"></ng-container>
      </tr>
    </ng-container>
  </ng-template>
  <!------------------------------


Card Element

------------------------------->
  <!-- no card Element -->


</sb-table-wrapper>

<ng-template #recursiveListTmpl let-list="list" let-level="level">
  <ng-container *ngFor="let schedule of list; index as index; last as last">
    <tr *ngIf="isDragging" [attr.data-schedule]="schedule?.precondition?.id" (drop)="onDrop($event, index)"
        (dragover)="onDragOver($event)">


      <td colspan="100" class="tw-text-center">
        {{ 'lang.globals.position' | translate }} {{ schedule.name }}
      </td>
    </tr>
    <tr [attr.data-schedule]="schedule?.id" (drop)="onDrop($event)" (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)" (dragover)="onDragOver($event)" (dragenter)="isDragging = true"
        [style.background]="isNumberEven(level) ? null : 'rgba(239, 239, 239, .75)'">
      <ng-container *ngTemplateOutlet="tds; context:{ schedule: schedule, level: level }"></ng-container>
    </tr>
    <ng-container *ngIf="schedule?.preconditionOf?.length > 0 && showChildren.has(schedule?.id)">
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: schedule.preconditionOf, level: level + 25 }">
      </ng-container>
    </ng-container>
    <tr *ngIf="last && isDragging" [attr.data-schedule]="schedule?.precondition?.id" (drop)="onDrop($event, index+1)"
        (dragover)="onDragOver($event)">


      <td colspan="100" class="tw-text-center">
        {{ 'lang.globals.positionAtEnd' | translate }} {{ schedule.name }}
      </td>
    </tr>
  </ng-container>
</ng-template>


<ng-template #tds let-schedule="schedule" let-level="level">
  <td *ngIf="(discussionService?.showRibbon || discussionService?.showDiscussionSideBar) && showList"
      [entityElement]="{type: discussionService.DISCUSSABLES.PlaybackSchedule, element: schedule}" [inTable]="true"
      [inline]="true"
      class="sticky-col first-col tableBg" sb-discussion>
  </td>
  <td>
    <ng-container *ngIf="!showList">
      <div *ngPermissions="permissionService.Permission.network_share_edit" class="btn btn-hover-primary mr-3"
           (mousedown)="onmousedown($event)" (mouseleave)="onmouseup($event)">
        <sb-icon icon="drag"></sb-icon>
      </div>
      <sb-icon *ngIf="schedule.preconditionOf && schedule.preconditionOf.length > 0 && showChildren.has(schedule?.id)"
               [style.margin-left.px]="level"
               [icon]="'minus'" class="cursor-pointer"
               (click)="toggleShowChildren(schedule)"></sb-icon>
      <sb-icon *ngIf="schedule.preconditionOf && schedule.preconditionOf.length > 0 && !showChildren.has(schedule?.id)"
               [style.margin-left.px]="level"
               [icon]="'plus'" class="cursor-pointer"
               (click)="toggleShowChildren(schedule)"></sb-icon>
      <sb-icon *ngIf="!(schedule.preconditionOf && schedule.preconditionOf.length > 0) && showChildren.has(schedule?.id)"
               [style.margin-left.px]="level"
               [icon]="'minus'" style="opacity: 0;"></sb-icon>
      <sb-icon *ngIf="!(schedule.preconditionOf && schedule.preconditionOf.length > 0) && !showChildren.has(schedule?.id)"
               [style.margin-left.px]="level"
               [icon]="'plus'" style="opacity: 0;"></sb-icon>
    </ng-container>
    &nbsp;
    {{ schedule.id }}
  </td>
  <td>{{ schedule?.level }}</td>
  <td>
    <sb-comp-name-wrapper>
      <sb-comp-link [link]="util.RoutingID.scheduleDetails" [pathParams]="[{id: 'scheduleID', value: schedule.id}]"
                    [permission]="permissionService.Permission.playback_schedule_show" [title]="schedule?.name"
                    container="body"
                    firstLine ngbTooltip="{{'lang.globals.openDetails' | translate}}">
      </sb-comp-link>
      <span *ngIf="schedule.precondition && showList" class="text-muted font-weight-bold"
            secondLine>{{ 'lang.globals.basedOn'|translate }}{{ schedule.precondition?.name }}</span>
      <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="schedule.id"
               [dtoType]="tagService.TaggableDTO.PlaybackSchedule"
               [tags]="schedule.tags" thirdLine></sb-tags>
    </sb-comp-name-wrapper>
  </td>
  <td>
    <sb-comp-filter-overview [geoCull]="schedule?.geoCull" [playerCull]="schedule?.playerCull"
                             [stateSpaceCull]="schedule?.stateSpaceCull" [timeCull]="schedule?.timeCull">
    </sb-comp-filter-overview>
  </td>
  <td>
    <ng-scrollbar [track]="'horizontal'" [autoHeightDisabled]="false"
                  style="max-width: 600px; width: 600px;">
					<span *ngIf="(!schedule.slots || schedule.slots.length === 0)">
						<h5 class="text-center"><i>{{ 'lang.schedules.noSlots' | translate }}</i></h5>
					</span>
      <div *ngFor="let slot of schedule.slots" [ngClass]="util.getSlotType(slot, 'Class')"
           class="card mr-1 mb-3"
           style="height: 100%; width: 68px; display: inline-block; overflow: hidden; color:white">
            <span [innerHTML]="util.getSlotType(slot, 'Name') | truncate : 5"
                  class="d-flex align-items-center justify-content-center px-4 py-3 "></span>
      </div>
    </ng-scrollbar>
  </td>
  <td>
    <sb-comp-display-modified [data]="schedule"></sb-comp-display-modified>
  </td>
  <td class="text-end sticky-col last-col tableBg">
    <sb-table-buttons>
      <a *ngPermissions="permissionService.Permission.playback_schedule_show"
         [pathParams]="[{id: 'scheduleID', value: schedule?.id}]"
         [sbRouterLink]="util.RoutingID.scheduleDetails"
         class="btn btn-primary"
         container="body" ngbTooltip="{{'lang.globals.openDetails' | translate}}">
        <sb-icon icon="details"></sb-icon>
      </a>
      <a *ngPermissions="permissionService.Permission.playback_schedule_edit"
         [pathParams]="[{id: 'scheduleID', value: schedule?.id}]"
         [queryParams]="{returnTo: util.getPageLink()}"
         [sbRouterLink]="util.RoutingID.scheduleEdit"
         class="btn btn-secondary"
         container="body" ngbTooltip="{{'lang.scheduleDetails.editScheduleSettings' | translate}}">
        <sb-icon icon="edit"></sb-icon>
      </a>
      <a (click)="deleteSchedule(schedule)" *ngPermissions="permissionService.Permission.playback_schedule_delete"
         class="btn btn-danger" container="body"
         ngbTooltip="{{'lang.globals.delete' | translate}}">
        <sb-icon icon="trash"></sb-icon>
      </a>
    </sb-table-buttons>
  </td>
</ng-template>
